const sufixos = [
  [1e12, 'tri'],
  [1e9, 'bi'],
  [1e6, 'mi']
  // [1e3, 'mil']
];

export const formatBRLAbbreviated = (valor, decimais = 2) => {
  if (typeof valor !== 'number' || isNaN(valor)) { return 'R$ 0,00'; }

  const abs = Math.abs(valor);
  const sinal = valor < 0 ? '- ' : '';

  for (const [limiar, sufixo] of sufixos) {
    if (abs >= limiar) {
      const abreviado = (abs / limiar).toFixed(decimais).replace('.', ',');
      return `R$ ${sinal}${abreviado} ${sufixo}`;
    }
  }

  const valorFormatado = abs.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  return `R$ ${sinal}${valorFormatado}`;
}

export const formatAdvancedBRL = (valor) => {
  if (typeof valor !== 'number' || isNaN(valor)) {
    return 'R$ 0,00';
  }

  const valorAbsoluto = Math.abs(valor);
  const valorFormatado = valorAbsoluto.toLocaleString('pt-BR', {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  });

  if (valor < 0) {
    return `R$ -${valorFormatado}`;
  } else {
    return `R$ ${valorFormatado}`;
  }
}

export default formatBRLAbbreviated;
